import { render, staticRenderFns } from "./Inter.vue?vue&type=template&id=08216e12&scoped=true&"
import script from "./Inter.js?vue&type=script&lang=js&"
export * from "./Inter.js?vue&type=script&lang=js&"
import style0 from "./Inter.scoped.scss?vue&type=style&index=0&id=08216e12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08216e12",
  null
  
)

export default component.exports